export default __webpack_public_path__ + "static/media/about.2e7f1e96.jpg";